import closeSelect from '@/shared/assets/icons/ui-kit/close-select-light.png';
import openSelect from '@/shared/assets/icons/ui-kit/open-select-light.png';

import * as RADIUS from '../../styles/radiuses';
import * as COLOR from './colors';
import { yachtTheme as theme } from './theme';

export const yachtDarkTheme = {
	colors: {
		primary: COLOR.LIME_1,
		secondary: COLOR.WHITE,
		tertiary: COLOR.GRAY_1,
		body: COLOR.DARK_2,
		metaColor: COLOR.DARK_2,
		...theme.colors,
	},
	input: {
		primary: {
			border: COLOR.GRAY_1,
			focus: COLOR.LIME_1,
			fontColor: COLOR.GRAY_6,
			background: COLOR.DARK_6,
			radius: RADIUS.PX_2,
			placeholderOpacity: 1,
		},
		secondary: {
			border: COLOR.GRAY_1,
			focus: COLOR.LIME_1,
			fontColor: COLOR.GRAY_6,
			background: COLOR.DARK_3,
			radius: RADIUS.PX_6,
			placeholderOpacity: 1,
		},
		tertiary: {
			border: 'transparent',
			focus: '#00D9FF',
			fontColor: COLOR.WHITE,
			background: 'rgba(40, 40, 40, 0.95)',
			radius: RADIUS.PX_8,
			placeholderOpacity: 0.5,
		},
		...theme.input,
	},
	textarea: {
		primary: {
			fontColor: COLOR.GRAY_6,
			placeholderColor: COLOR.GRAY_6,
			background: COLOR.DARK_6,
			focus: COLOR.LIME_1,
			border: COLOR.GRAY_1,
			radius: RADIUS.PX_2,
			placeholderOpacity: 1,
		},
		secondary: {
			fontColor: COLOR.GRAY_6,
			placeholderColor: COLOR.GRAY_6,
			background: COLOR.DARK_6,
			focus: COLOR.LIME_1,
			border: COLOR.GRAY_1,
			radius: RADIUS.PX_6,
			placeholderOpacity: 1,
		},
		tertiary: {
			border: 'transparent',
			focus: '#00D9FF',
			fontColor: COLOR.WHITE,
			placeholderColor: COLOR.WHITE,
			background: 'rgba(40, 40, 40, 0.95)',
			radius: RADIUS.PX_8,
			placeholderOpacity: 0.5,
		},
		...theme.textarea,
	},
	box: {
		border: COLOR.GRAY_1,
		background: COLOR.DARK_6,
	},
	checkbox: {
		background: COLOR.LIME_1,
		border: COLOR.LIME_1,
	},
	logo: {
		fill: COLOR.DARK_3,
		stroke: COLOR.GRAY_1,
	},
	page: {
		...theme.page,
		wrapper: {
			background: COLOR.DARK_4,
			border: `1px solid ${COLOR.GRAY_1}`,
		},
	},
	text: {
		size: {
			...theme.text.size,
		},
		colors: {
			primary: COLOR.WHITE,
			secondary: COLOR.GRAY_10,
			tertiary: COLOR.LIME_1,
			quaternary: COLOR.LIME_1,
			quinary: COLOR.GRAY_2,
			invertedPrimary: COLOR.GRAY_11,
			invertedSecondary: COLOR.LIME_1,
			invertedTertiary: COLOR.WHITE,
			invertedQuaternary: COLOR.GRAY_10,
			textSecondary: COLOR.GRAY_13,
			inherit: 'inherit',
			...theme.colors,
		},
	},
	chip: {
		background: COLOR.DARK_3,
		borderColor: COLOR.LIME_1,
	},
	download: {
		hover: COLOR.DARK_5,
	},
	button: {
		...theme.button,
		error: {
			background: 'transparent',
			border: `1px solid ${COLOR.ERROR}`,
			color: COLOR.ERROR,

			'&:hover': {
				opacity: 0.85,
			},

			'&:active': {
				opacity: 1,
			},

			'&:disabled': {
				opacity: 0.7,
				cursor: 'initial',
			},
		},
		login: {
			background: '#00D9FF',
			border: '1px solid transparent',
			color: COLOR.DARK_1,

			'&:hover': {
				background: '#00C4E6',
				transform: 'translateY(-2px)',
			},
		},
		contained: {
			background: COLOR.LIME_1,
			border: '1px solid transparent',
			color: COLOR.DARK_1,

			'&:hover': {
				background: COLOR.LIME_2,
			},

			'&:active': {
				background: COLOR.LIME_1,
			},

			'&:disabled': {
				background: COLOR.LIME_5,
				cursor: 'initial',
			},
		},
		containedInverted: {
			background: COLOR.LIME_1,
			border: '1px solid transparent',
			color: COLOR.WHITE,

			'&:hover': {
				background: COLOR.LIME_2,
			},

			'&:active': {
				background: COLOR.LIME_1,
			},
		},
		outlined: {
			background: 'transparent',
			color: COLOR.LIME_1,
			border: `1px solid ${COLOR.LIME_1}`,

			'&:hover': {
				background: 'rgb(165, 225, 31, 0.1)',
			},

			'&:active': {
				background: COLOR.LIME_1,
			},

			'&:disabled': {
				border: `1px solid ${COLOR.LIME_5}`,
				['pointer-events']: 'none',
				color: COLOR.LIME_5,
			},
		},
		outlinedInverted: {
			background: 'transparent',
			color: COLOR.WHITE,
			border: `1px solid ${COLOR.WHITE}`,

			'&:hover': {
				background: COLOR.LIME_2,
			},

			'&:active': {
				background: COLOR.LIME_1,
			},
		},
		containedPrimary: {
			background: COLOR.LIME_1,
			border: '1px solid transparent',
			color: COLOR.DARK_1,

			'&:hover': {
				background: COLOR.LIME_2,
			},

			'&:active': {
				background: COLOR.LIME_2,
			},
		},
		outlinedPrimary: {
			background: 'transparent',
			color: COLOR.LIME_1,
			border: `1px solid ${COLOR.LIME_1}`,

			'&:hover': {
				background: 'rgb(165, 225, 31, 0.1)',
			},

			'&:active': {
				background: COLOR.LIME_1,
			},

			'&:disabled': {
				border: 'none',
				['pointer-events']: 'none',
				color: '#9D9D9D',
			},
		},
		containedSecondary: {
			background: COLOR.BLUE_1,
			border: '1px solid transparent',
			color: COLOR.WHITE,

			'&:hover': {
				background: COLOR.BLUE_2,
			},

			'&:active': {
				background: COLOR.BLUE_1,
			},

			'&:disabled': {
				background: COLOR.BLUE_5,
				cursor: 'initial',
			},
		},
	},
	title: {
		colors: {
			primary: COLOR.WHITE,
			secondary: COLOR.DARK_1,
		},
		...theme.title,
	},
	toggle: {
		background: COLOR.GRAY_1,
		fill: COLOR.LIME_1,
		moon: COLOR.DARK_1,
		sun: COLOR.GRAY_10,
	},
	link: {
		color: COLOR.GRAY_8,
		active: {
			background: COLOR.LIME_1,
			colors: {
				primary: COLOR.DARK_4,
				secondary: COLOR.WHITE,
			},
		},
	},
	avatar: {
		...theme.avatar,
	},
	layouts: {
		header: {
			...theme.layouts.header,
			background: COLOR.DARK_4,
			borderBottom: `1px solid ${COLOR.GRAY_1}`,
			icon: {
				primary: COLOR.WHITE,
			},
		},
		sidebar: {
			...theme.layouts.sidebar,
			background: COLOR.DARK_4,
			borderRight: `1px solid ${COLOR.GRAY_1}`,
			borderBottom: `1px solid ${COLOR.GRAY_1}`,
			bottomIcon: {
				fill: COLOR.DARK_4,
				border: COLOR.GRAY_11,
				path: COLOR.GRAY_11,
			},
			toggle: {
				fill: COLOR.DARK_4,
				stroke: COLOR.GRAY_1,
			},
		},
	},
	isDark: true,
	menu: {
		background: COLOR.DARK_6,
		hover: COLOR.DARK_5,
		border: `1px solid ${COLOR.GRAY_1}`,
	},
	stepper: {
		colors: {
			primary: COLOR.LIME_1,
			disabled: COLOR.GRAY_7,
		},
		border: {
			primary: COLOR.LIME_1,
			disabled: COLOR.GRAY_1,
		},
	},
	autocomplete: {
		...theme.autocomplete,
	},
	datepicker: {
		color: {
			primary: COLOR.WHITE,
			scheme: 'dark',
		},
		hover: COLOR.DARK_5,
		...theme.datepicker,
	},
	leaflet: {
		color: {
			primary: COLOR.WHITE,
		},
	},
	option: {
		background: COLOR.DARK_6,
		hover: COLOR.DARK_5,
		border: `1px solid ${COLOR.GRAY_1}`,
		color: COLOR.GRAY_8,
	},
	select: {
		arrow: {
			open: openSelect,
			close: closeSelect,
		},
	},
	zIndex: {
		...theme.zIndex,
	},
	tabs: {
		color: COLOR.GRAY_7,
		activeColor: COLOR.LIME_1,
		background: COLOR.DARK_2,
		border: `1px solid ${COLOR.GRAY_1}`,
		...theme.tabs,
	},
	table: {
		headColor: COLOR.WHITE,
		measurementBackground: COLOR.DARK_6,
		bodyColor: COLOR.GRAY_10,
		background: COLOR.DARK_6,
		headBackground: COLOR.DARK_5,
		border: `1px solid ${COLOR.GRAY_1}`,
		offlineBackground: COLOR.GRAY_1,
		...theme.table,
	},
	toast: {
		background: COLOR.DARK_5,
		closeColor: COLOR.WHITE,
	},
	caption: {
		primary: COLOR.WHITE,
		secondary: COLOR.GRAY_9,
		tertiary: COLOR.WHITE,
		quaternary: COLOR.GRAY_10,
		gray: COLOR.GRAY_11,
		dark: COLOR.GRAY_5,
	},
	tag: {
		border: COLOR.LIME_1,
		radius: RADIUS.PX_5,
		background: 'transparent',
		color: COLOR.LIME_1,
		...theme.tag,
	},
	list: {
		color: COLOR.WHITE,
	},
	container: {
		border: COLOR.GRAY_1,
		radius: RADIUS.PX_2,
	},
	section: {
		border: COLOR.GRAY_1,
		color: COLOR.GRAY_10,
	},
	breadcrumbs: {
		color: COLOR.LIME_1,
		background: 'transparent',
		border: `1px solid ${COLOR.LIME_1}`,
		radius: RADIUS.PX_2,
	},
	transition: {
		...theme.transition,
	},
	modal: {
		border: COLOR.GRAY_1,
		borderInside: COLOR.GRAY_1,
		background: COLOR.DARK_3,
		backgroundActions: COLOR.DARK_6,
		backgroundHeader: COLOR.DARK_5,
		icon: COLOR.WHITE,
		color: COLOR.WHITE,
	},
	pagination: {
		color: COLOR.GRAY_8,
		background: 'transparent',
		border: `1px solid ${COLOR.GRAY_1}`,
		active: {
			background: COLOR.LIME_1,
			color: COLOR.DARK_1,
		},
	},
	widgets: {
		circle: { color: COLOR.LIME_2, background: COLOR.LIME_10 },
		arrow: COLOR.WHITE,
		addSection: {
			background: COLOR.DARK_5,
		},
	},
	tooltip: {
		background: COLOR.DARK_4,
		hover: COLOR.DARK_5,
		border: `1px solid ${COLOR.GRAY_1}`,
		color: {
			primary: COLOR.LIME_1,
			secondary: COLOR.GRAY_5,
		},
	},
	breakpoints: {
		...theme.breakpoints,
	},
	media: {
		...theme.media,
	},
	radio: {
		color: COLOR.GRAY_8,
		active: COLOR.LIME_1,
	},
	spinner: {
		...theme.spinner,
		color: {
			primary: COLOR.LIME_1,
			secondary: COLOR.WHITE,
		},
	},
	map: {
		icon: COLOR.WHITE,
	},
	windy: {
		icon: {
			background: COLOR.LIME_1,
			fill: {
				active: COLOR.DARK_1,
				unactive: COLOR.WHITE,
			},
			...theme.windy.icon,
		},
		buttons: {
			background: COLOR.GRAY_12,
			...theme.windy.buttons,
		},
	},
	dashboard: {
		icon: {
			expand: COLOR.LIME_1,
		},
	},
	notification: {
		icon: {
			backgroundColor: COLOR.LIME_10,
			activeColor: COLOR.LIME_1,
		},
		card: {
			activeBackground: 'none',
			defaultBorder: COLOR.DARK_6,
			border: COLOR.LIME_1,
		},
		menu: {
			icon: COLOR.WHITE,
		},
	},
	icon: {
		roundWrapper: {
			primary: {
				backgroundColor: COLOR.LIME_10,
				fill: COLOR.LIME_1,
			},
			secondary: {
				backgroundColor: COLOR.GRAY_10,
				fill: COLOR.GRAY_5,
			},
		},
	},
	skeleton: {
		gradient: `linear-gradient(to right, ${COLOR.LIME_1} 0%, ${COLOR.LIME_2} 50%, ${COLOR.LIME_3} 100%)`,
		shadow: COLOR.LIME_5,
	},
	marker: {
		primary: COLOR.BLUE_1,
		secondary: COLOR.GRAY_2,
		error: COLOR.ERROR,
	},
};
